import React from 'react'
import Svg, { G, Circle, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconList = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconList.dimensions.width} ${IconList.dimensions.height}`}
      {...otherProps}
    >
      <G fill="none" fillRule="evenodd">
        <Path
          stroke={color || Color.premiumBlack}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M27 2H6M27 14H6M27 26H6"
        />
        <Circle fill={color || Color.premiumBlack} cx={1.5} cy={2} r={1.5} />
        <Circle fill={color || Color.premiumBlack} cx={1.5} cy={14} r={1.5} />
        <Circle fill={color || Color.premiumBlack} cx={1.5} cy={26} r={1.5} />
      </G>
    </Svg>
  )
}

IconList.dimensions = {
  width: 28,
  height: 28,
}

export default IconList
